import { NgReason } from '@/types/receipt'

export const ngReasons = Object.values(NgReason).map(value => {
  return {
    value,
    text: value,
  }
})
